class ShippingArea extends HTMLElement {
  constructor() {
      super();

      // Get radio buttons and content divs
      this.form = this.querySelector('form');
      this.cartForm = document.querySelector('#cart');
      this.shipToHomeRadio = this.querySelector('#ship-to-home');
      this.shipToStoreRadio = this.querySelector('#ship-to-store');
      this.shipToHomeContent = this.querySelector('#ship-to-home-content');
      this.shipToStoreContent = this.querySelector('#ship-to-store-content');
      this.labels = this.querySelectorAll('label');
      
      // Bind event listeners
      this.locationSelector = this.querySelector('.location-selector');
      this.checkoutButtons = document.querySelectorAll('.cart__checkout-button');

      const debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 50);
  
      this.addEventListener('change', debouncedOnChange.bind(this));

      this.init();
      this.cartUpdate();
  }

  async init(){
    this.locations = await this.loadLocations();
    this.cartUpdate();
  }

  async getCart() {
    return fetch(`/cart.js`).then((response) => {
      return response.json();
    });
  }

  async loadLocations() {

    var url = 'https://sb.caasco.ca/ShopifyService/ext/api/store/locations';
    var auth = 'U2hvcGlmeUFwcDo1Y1A4MkZzcVkw'
    let clubcode = 275;

    let payload = {
      clubCode: clubcode
    };

    const config = {
      method: 'POST',
      headers: {
        "TransactionID": Date.now(),
        "Authorization": `Basic ${auth}`,
        "content-type": "application/json",
        "accept": "application/json",
      },
      body: JSON.stringify(payload)
    }

    const response = await fetch(url, config)
      .then((response) => response.json())
      .then(async (response) => {

        var cart = await this.getCart();
        var location = cart.attributes.location ? cart.attributes.location : null;

        if(response.ResponseStatus && response.ResponseStatus.StatusCode == 1){
          response.StoreLocations.forEach(location => {
            var option = document.createElement("option");
            option.dataset.location = JSON.stringify(location);
            option.text = location.StoreName;
            option.value = location.StoreNumber; // You can set a different value if needed
            this.locationSelector.appendChild(option);
          });
        }

        return response;
      })
      .catch((e) => {
        console.error(e);
      });

      return response.StoreLocations;

  }

  onChange(evt){

    if(evt.target !== this.locationSelector) this.locationSelector.selectedIndex = 0;

    this.checkoutButtons.forEach(button => button.disabled = true);
    this.labels.forEach(label => label.classList.remove('selected'));

    let label = evt.target.closest('label');
    label.classList.add('selected');

    this.cartUpdate();
  }


  cartUpdate(){
    var cart_attr = {
      shipping_method: '',
      location: '',
      locationData: ''
    }

    const formData = new FormData(this.form);

    for(var pair of formData.entries()){
      cart_attr[pair[0]] = pair[1];
      if(pair[0] == 'location'){
        cart_attr.locationData = JSON.stringify(this.locations.filter(location => location.StoreNumber === pair[1])[0]);
      } else {
        cart_attr.locationData = '';
      }
    }

    const body = JSON.stringify({ attributes: cart_attr });
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => response.json())
    .then(async (response) => {
      if(response.attributes?.shipping_method == 'store' && !response.attributes?.location){
        this.checkoutButtons.forEach(button => button.disabled = true);
      } else {
        this.checkoutButtons.forEach(button => button.disabled = false);
      }

      console.log('cart update', response);

    })
    .catch((e) => {
      console.error(e);
    });
  }
}
// Define the custom element
customElements.define('shipping-area', ShippingArea);


class MemberModule extends HTMLElement {
  constructor() {
      super();

      this.memberField = this.querySelector('input[name="member_id"]');
      
      this.memberErrors = this.querySelector('.member-errors');
      this.memberDiscounts = this.querySelector('.member-discounts');
      this.submitButton = this.querySelector('button');
      this.cart = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
      
      this.submitButton.addEventListener('click', this.formSubmit.bind(this));  
      
      if(this.memberField){
        var membership_number = document.querySelector('input[name="member_id"]').value

        console.log('LETS ADD TO NOTES', membership_number)

        this.addToNotes(membership_number)
      }

  }

  addToNotes(member_number) {

    console.log('LETS ADD TO NOTES INIT', member_number)

    const object = { 
      note: member_number,
      attributes: { 
        member_id: member_number 
      }
    };

    console.log('THIS IS WHAT WE ARE SENDING TO MEMBER API', object)

    const body = JSON.stringify(object);
    
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => response.json())
    .then(async (response) => {
      console.log('addToNotes response', response)
    })
    .catch((e) => {
      console.error(e);
    });
  }

  async getCart() {
    return fetch(`/cart.js`).then((response) => {
      return response.json();
    });
  }

  async asyncForEach(array, callback) {
    for (const item of array) {
      await callback(item);
    }
  }

  enableLoading(){
    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.querySelector('.loading__spinner').classList.remove('hidden');
  }

  disableLoading(){
    this.submitButton.classList.remove('loading');
    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
    this.querySelector('.loading__spinner').classList.add('hidden');
  }

  async formSubmit(evt){
    evt.preventDefault();

    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    if(this.submitButton.classList.contains('edit')){
      this.memberField.disabled = false;
      this.memberField.value = '';
      this.submitButton.querySelector('span').innerText = 'Submit'
      this.submitButton.classList.remove('edit');
      this.submitButton.classList.add('submit');
      return;
    }

    this.enableLoading();

    if(!this.memberField.value) {
      this.disableLoading();
      this.memberErrors.innerHTML = `<div class="alert danger">Please enter Member ID number</div>`; 
      return
    }

    const response = await this.validateMember();

    let svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M13.28 9.03a.75.75 0 0 0-1.06-1.06l-2.97 2.97-1.22-1.22a.75.75 0 0 0-1.06 1.06l1.75 1.75a.75.75 0 0 0 1.06 0l3.5-3.5Z"/><path fill-rule="evenodd" d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"/></svg>`;

    if(response && response.ResponseStatus && response.ResponseStatus.StatusCode == 1){
      this.memberErrors.innerHTML = `<div class="alert success">${svg} Success</div>`;
    
      var cart = await this.getCart();

      if(cart.items.length > 0){
        var line = 1;
        await this.asyncForEach(cart.items, async (item) => {
          this.cart.updateQuantity(line, item.quantity)
          line++;
        });
      }

      this.memberField.disabled = true;
      this.submitButton.querySelector('span').innerText = 'Edit'
      this.submitButton.classList.remove('submit');
      this.submitButton.classList.add('edit');

      this.addToNotes(document.querySelector('input[name="member_id"]').value);
    } else {
      this.memberField.value = '';
      this.memberErrors.innerHTML = `<div class="alert danger"><span><strong>Member not found.</strong> <br> <span class="small">Member pricing has not been applied to your order. To obtain member pricing, enter your valid CAA membership number above.</span></span></div>`;
    }

    this.disableLoading();
  }

  async validateMember() {
    var APIURL = '';
    var AUTH = '';
    var CLUBCODE = '';

    switch (Shopify.shop) {
      case 'devsitecaastore.myshopify.com':
        APIURL = 'https://sbqa.caasco.ca/QA431/ShopifyService/ext/api/customer-update';
        AUTH = 'Basic U2hvcGlmeUFwcDpjYWF0ZXN0';
        CLUBCODE = 282;
        break;
      case 'caa-store-1.myshopify.com':
        APIURL = 'https://sb.caasco.ca/ShopifyService/ext/api/customer-update';
        AUTH = 'Basic U2hvcGlmeUFwcDo1Y1A4MkZzcVkw';
        CLUBCODE = 282;
        break;
      case 'sitedevmbstore.myshopify.com':
        APIURL = 'https://sbqa.caasco.ca/QA431/ShopifyService/ext/api/customer-update';
        AUTH = 'Basic U2hvcGlmeUFwcDpjYWF0ZXN0';
        CLUBCODE = 275;
        break;
      case 'caa-manitoba-prod.myshopify.com':
        APIURL = 'https://sb.caasco.ca/ShopifyService/ext/api/customer-update';
        AUTH = 'Basic U2hvcGlmeUFwcDo1Y1A4MkZzcVkw';
        CLUBCODE = 275;
        break;
      default:
        APIURL = '';
        AUTH = '';
        CLUBCODE = 0;
        break;
    }

    let payload = {
      member_id : this.memberField.value.toString(),
      customer_id : this.dataset.customerId.toString(),
      clubCode: CLUBCODE
    };

    const config = {
      method: 'POST',
      headers: {
        "TransactionID": Date.now(),
        "Authorization": AUTH,
        "content-type": "application/json",
        "accept": "application/json",
      },
      body: JSON.stringify(payload)
    }

    try {
      const response = await fetch(APIURL, config);
      return await response.json();
    } catch (e) {
      console.error(e);
      return { error: true, message: e.message };
    }
  }
}
// Define the custom element
customElements.define('member-module', MemberModule);


class MemberDetails extends HTMLElement {
  constructor() {
    super();
    this.memberId = JSON.parse(this.dataset.tags)[1].replace('M-', '');
    this.customerId = this.dataset.customerId;
    this.cart = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');

    this.memberDetailsInit();
  }

  async asyncForEach(array, callback) {
    for (const item of array) {
      await callback(item);
    }
  }

  addToNotes(member_number) {

    console.log('LETS ADD TO NOTES INIT', member_number)

    const object = { 
      note: member_number,
      attributes: { 
        member_id: member_number 
      }
    };

    console.log('THIS IS WHAT WE ARE SENDING TO MEMBER API', object)

    const body = JSON.stringify(object);
    
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => response.json())
    .then(async (response) => {
      console.log('addToNotes response', response)
    })
    .catch((e) => {
      console.error(e);
    });
  }

  async getCart() {
    return fetch(`/cart.js`).then((response) => {
      return response.json();
    });
  }

  async memberDetailsInit() {
    const response = await this.validateMember();

    if(response && response.ResponseStatus && response.ResponseStatus.StatusCode == 1){

      var cart = await this.getCart();

      if(cart.items.length > 0){
        var line = 1;
        await this.asyncForEach(cart.items, async (item) => {
          this.cart.updateQuantity(line, item.quantity)
          line++;
        });
      }

      this.addToNotes(this.memberId);

    }
  }

  async validateMember() {
    var APIURL = '';
    var AUTH = '';
    var CLUBCODE = '';

    switch (Shopify.shop) {
      case 'devsitecaastore.myshopify.com':
        APIURL = 'https://sbqa.caasco.ca/N1QA432/ShopifyService/ext/api/customer-update';
        AUTH = 'Basic U2hvcGlmeUFwcDpjYWF0ZXN0';
        CLUBCODE = 282;
        break;
      case 'caa-store-1.myshopify.com':
        APIURL = 'https://sb.caasco.ca/ShopifyService/ext/api/customer-update';
        AUTH = 'Basic U2hvcGlmeUFwcDo1Y1A4MkZzcVkw';
        CLUBCODE = 282;
        break;
      case 'sitedevmbstore.myshopify.com':
        APIURL = 'https://sbqa.caasco.ca/N1QA432/ShopifyService/ext/api/customer-update';
        AUTH = 'Basic U2hvcGlmeUFwcDpjYWF0ZXN0';
        CLUBCODE = 275;
        break;
      case 'caa-manitoba-prod.myshopify.com':
        APIURL = 'https://sb.caasco.ca/ShopifyService/ext/api/customer-update';
        AUTH = 'Basic U2hvcGlmeUFwcDo1Y1A4MkZzcVkw';
        CLUBCODE = 275;
        break;
      default:
        APIURL = '';
        AUTH = '';
        CLUBCODE = 0;
        break;
    }

    let payload = {
      member_id : this.memberId.toString(),
      customer_id : this.customerId.toString(),
      clubCode: CLUBCODE
    };

    const config = {
      method: 'POST',
      headers: {
        "TransactionID": Date.now(),
        "Authorization": AUTH,
        "content-type": "application/json",
        "accept": "application/json",
      },
      body: JSON.stringify(payload)
    }

    try {
      const response = await fetch(APIURL, config);
      return await response.json();
    } catch (e) {
      console.error(e);
      return { error: true, message: e.message };
    }
  }
}

customElements.define('member-details', MemberDetails);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, 'remove');
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => response.json())
            .then(async (response) => {
              console.log('response', response)
            })
            .catch((e) => {
              console.error(e);
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
